import { KEYS } from 'platejs';

export const PLATE_KEYS = {
	...KEYS,
	affiliateLink: 'affiliateLink',
	spoiler: 'spoiler',
};
